import { useMemo } from 'react';

export function normalizeText(value: unknown): string {
  return String(value ?? '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase();
}

/** Filtra a lista pelo texto digitado, ignorando acentos e maiúsculas. */
export function useTextSearch<T>(
  items: T[],
  search: string,
  getText: (item: T) => unknown[]
): T[] {
  return useMemo(() => {
    const term = normalizeText(search).trim();
    if (!term) return items;

    return items.filter((item) =>
      getText(item).some((value) => normalizeText(value).includes(term))
    );
    // getText é recriada a cada render; o filtro só depende da lista e do termo.
  }, [items, search]);
}
